import { render, staticRenderFns } from "./ContasPagar.vue?vue&type=template&id=6f87e6bb&scoped=true&"
import script from "./contasPagar.js?vue&type=script&lang=js&"
export * from "./contasPagar.js?vue&type=script&lang=js&"
import style0 from "./ContasPagar.vue?vue&type=style&index=0&id=6f87e6bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87e6bb",
  null
  
)

export default component.exports